export const dataConverter = (rawData)=>{
  // converts json data into FormData
  let keys = Object.keys(rawData)
  let formattedData = new FormData()
  keys.forEach((key)=>{
    formattedData.append(key,rawData[key])
  })
  return formattedData
}